import React from "react";
import FormPostulante from "./FormPostulante";

const Form = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-app">
      <div className="bg-shape bg-shape-a" />
      <div className="bg-shape bg-shape-b" />

      <main className="relative z-10 px-4 py-10 sm:px-8 lg:px-12">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-6 lg:grid-cols-12">
          <section
            className="glass-panel lg:col-span-4 animate-rise"
            style={{ animationDelay: "60ms" }}
          >
            <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-muted">
              Talento Humano
            </p>
            <h1 className="mt-3 text-3xl font-bold leading-tight text-brand-ink">
              Registro de postulantes
            </h1>
            <p className="mt-4 text-sm leading-6 text-brand-subtle">
              Completa el formulario para iniciar tu proceso de selección en
              HRM. Nuestro equipo revisará tu información y se contactará
              contigo.
            </p>

            <div className="mt-8 rounded-2xl border border-brand-line bg-white/80 p-5">
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand-muted">
                Proceso
              </p>
              <ul className="mt-3 space-y-3 text-sm text-brand-subtle">
                <li className="flex items-center gap-2">
                  <span className="status-dot" /> Validación de datos
                </li>
                <li className="flex items-center gap-2">
                  <span className="status-dot" /> Filtro de perfil
                </li>
                <li className="flex items-center gap-2">
                  <span className="status-dot" /> Contacto de reclutamiento
                </li>
              </ul>
            </div>
          </section>

          <section
            className="glass-panel lg:col-span-8 animate-rise"
            style={{ animationDelay: "120ms" }}
          >
            <FormPostulante />
          </section>
        </div>
      </main>
    </div>
  );
};
export default Form;
